export class Guides {
  constructor(
    breakpoints = {
      "(max-width: 1000px)": 6,
    }
  ) {
    this.breakpoints = breakpoints;
    this.guides = document.createElement("div");
    this.guides.className = "guides wrap";

    this.updateColumns();
    document.body.appendChild(this.guides);

    if (localStorage.getItem("guides") === "true") {
      this.guides.style.visibility = "visible";
    }

    document.addEventListener("keydown", (e) => {
      if (e.key === "g" && e.ctrlKey) {
        const visible = this.guides.style.visibility === "visible";
        this.guides.style.visibility = visible ? "hidden" : "visible";
        localStorage.setItem("guides", !visible);
      }
    });

    window.addEventListener("resize", () => {
      this.updateColumns();
      this.guides.dataset.windowWidth = window.innerWidth;
    });
  }

  getCurrentColumns() {
    for (const [query, columns] of Object.entries(this.breakpoints)) {
      if (window.matchMedia(query).matches) {
        return columns;
      }
    }
    return 12;
  }

  updateColumns() {
    const columns = this.getCurrentColumns();
    this.guides.innerHTML = `
      <div class="inner grid">
        ${Array(columns).fill('<div class="guides__guide"></div>').join("")}
      </div>
    `;
  }
}
